import { plural } from '../../../../../shared/helpers/plural';
import { INFO_PANEL_TYPE } from '../../../generic';
import InfoPanel from '../../../generic/InfoPanel';
import Text from '../../../generic/Text';
import type {
  PackageLabelForTable,
} from '../../../settings/organization/general/PackageLabelsSelector/PackageLabelSelector';

import styles from './dialogBodies.module.less';

/**
 * Returns the JSX for the confirmation dialog when editing a label.
 */
export const editLabelDialogBody = (editedItem: PackageLabelForTable, newLabel: string) => {
  return (
    <>
      <div className={styles.header}>
        Are you sure you&apos;d like to update the label from &quot;{editedItem.name}&quot; to &quot;{newLabel}&quot;?
      </div>
      {editedItem.packageCount ? (
        <InfoPanel type={INFO_PANEL_TYPE.WARNING}>
          This label will be changed in the <b>{editedItem.packageCount}</b>{' '}
          {plural(editedItem.packageCount, 'package')} using it.
        </InfoPanel>
      ) : (
        <InfoPanel>This label isn&apos;t used in any packages.</InfoPanel>
      )}
      <div className={styles.info}>
        <Text.Micro>
          Note: This change will take effect immediately, and will not require saving your organization settings.
        </Text.Micro>
      </div>
    </>
  );
};
